import * as React from 'react';
import * as Yup from 'yup';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikActions, FormikProps } from 'formik';

import { History } from 'history';
import { Member } from 'common/api/models/Member';
import { FormInput } from 'common/components/form/FormInput';

interface CertDialogProps {
  user?: Member;
  history: History;
  onCancel: () => void;
}
class CertDialogValues {
  cert: string = '';
}

export class CertDialog extends React.Component<CertDialogProps> {
  validationSchema = Yup.object().shape({
    cert: Yup.string().required('Required'),
  });

  handleSubmit = (values: CertDialogValues, actions: FormikActions<CertDialogValues>) => {
    this.props.history.push('/checkout?cert=' + values.cert + '&memberId=' + this.props.user!.id!);
  };

  render() {
    return (
      <Modal size="md" isOpen={!!this.props.user} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={{ cert: 'AKBD' }}
          validationSchema={this.validationSchema}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<CertDialogValues>) => (
            <form onSubmit={form.handleSubmit} noValidate={true}>
              <ModalHeader toggle={this.props.onCancel}>Purchase Certification</ModalHeader>
              <ModalBody>
                <div className="row">
                  <div className="col">
                    <FormInput id="cert" name="cert" tag="select" label="Type" autoComplete="off">
                      <option>AKBD</option>
                      <option>CBD</option>
                      <option>CKD</option>
                      <option value="CKD-CBD">CKD + CBD</option>
                      <option>CKBD</option>
                      <option>CKBI</option>
                      <option>CMKBD</option>
                    </FormInput>
                  </div>
                </div>
                {form.status && <div className="alert alert-danger">{form.status}</div>}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Users/CertDialog.tsx